import { WayPoint } from '@bringg/types';

const sortWaypointsByPosition = (wayPoints: WayPoint[]) => wayPoints.sort((a, b) => a.position - b.position);
export default sortWaypointsByPosition;
